import {Component, OnInit, AfterViewInit, ViewChild, ElementRef} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {HttpClient} from '@angular/common/http';

import {Message} from "primeng/components/common/api";

import * as _ from 'lodash';
import * as moment from 'moment';

import {SelectItem} from 'primeng/primeng';

import {Page} from "../../api/model/page";
import {Image} from "../../api/model/image";
import {AwsService} from "../aws.service";

import {Utils} from '../utils';
import {config} from '../config';
import * as jodit_es from '../jodit-es';
import { Schema } from '../../api/model/schema';
import * as Ajv from 'ajv';

const slugize = require('hexo-util/lib/slugize');
const Permalink = require('hexo-util/lib/permalink');

declare var Jodit: any;

@Component({
    template: require('./page-form.component.pug'),
    styles: [require('./page-form.component.css')]
})
export class PageFormComponent implements OnInit, AfterViewInit {
    msgs: Message[] = [];

    @ViewChild('editor') el: ElementRef;
    private _editor: any;

    action: string = 'create';
    siteId: string;
    siteUrl: string;

    model: Page = {images: [], seo: {}};
    path: string;

    imageDialog: boolean = false;
    selectedImage: Image = {};

    private _imageBaseUrl: string;
    private _imageFilename: string;

    layouts: SelectItem[] = [];
    layout: string;

    ajv: Ajv.Ajv = new Ajv();
    form: any = {};
    schemas: SelectItem[] = [];
    schema: Schema = {};
    data: any = {};

    constructor(private route: ActivatedRoute, private _awsService: AwsService) {
        console.log('[PageFormComponent][constructor]');
        this.siteId = localStorage.getItem('currentSite');
    }

    async ngOnInit() {
        console.log('[PageFormComponent][ngOnInit]', this.siteId);
        const additionalParams = {queryParams: {ConsistentRead: true}};
        const schemas = (await this._awsService.api.sitesSiteSchemasGet({site: this.siteId}, {}, additionalParams)).data.items;
        this.schemas.push({label: 'Selecciona', value: null});
        schemas.forEach((schema:any) => this.schemas.push({label: schema.name, value: schema}))
        console.log(this.schemas);

        this.msgs = [];
        try {
            const site = (await this._awsService.api.sitesSiteGet({site: this.siteId})).data;
            const schema = (site.ssl) ? 'https://' : 'http://';
            const domain = (site.cname) ? site.cname : site.id + '.sintesis.io';
            this.siteUrl = schema + domain + '/';

            const theme = (await this._awsService.api.sitesSiteThemesNameGet({site: this.siteId, name: site.theme})).data;
            for (let layout of theme.layouts) this.layouts.push({label: layout, value: layout});
            this.model.layout = 'page';

            let id = this.route.snapshot.paramMap.get("id");
            if (id !== "new") {
                this.model = (await this._awsService.api.sitesSitePagesPathGet({site: this.siteId, path: id})).data;
                this.fromModel();
                this.action = 'update';
            }
        } catch (err) {
            this.msgs.push({severity: 'error', summary: 'Error en la carga', detail: err});
        }
   }

    ngAfterViewInit() {
        console.log('[PageFormComponent][ngAfterViewInit]');
        const editorOps = {
            language: 'es',
            //debugLanguage: true,
            i18n: {es: jodit_es.default},
            buttons: ['source', '|', 'bold', 'italic', '|', 'ul', 'ol', '|', 'font', 'fontsize', 'brush', 'paragraph', '|', 'image', 'video', 'table', 'link', '|', 'align', '|', 'undo', 'redo', '|', 'hr', 'eraser', 'fullsize'],
            uploader: {
                url: config.S3_ENDPOINT,
                format: 'text',
                prepareData: async (formData: FormData) => {
                    if (formData.has('files[0]')) {
                        let file: any = formData.get('files[0]');
                        let filename = slugize(Utils.basename(file.name)) + '.' + Utils.extension(file.name);
                        let path = config.S3_PREFIX + this._awsService.identityId + '/pages/up/';
                        let params = {
                            Bucket: config.S3_BUCKET,
                            Fields: {
                                key: path + filename,
                                acl: 'public-read',
                                success_action_status: '200'
                            }
                        };
                        const s3 = new this._awsService.AWS.S3(this._awsService.credentials);
                        let data = await (new Promise<any>((res, rej) => {
                            s3.createPresignedPost(params, (err: any, data: any) => (err) ? rej(err) : res(data));
                        }));
                        for (let key of Object.keys(data.fields)) {
                            formData.set(key, data.fields[key]);
                        }
                        formData.append('file', file);
                        this._imageBaseUrl = data.url + '/';
                        this._imageFilename = path + filename;
                    }
                    formData.delete('path');
                    formData.delete('source');
                    formData.delete('files[0]');
                    return formData;
                },
                getMessage: (resp: any) => {
                    return "OK";
                },
                isSuccess: (resp: any) => {
                    return true;
                },
                process: (resp: any, data: any) => {
                    return {
                        files: resp.files || [this._imageFilename],
                        path: resp.path,
                        baseurl: resp.baseurl || this._imageBaseUrl,
                        error: resp.error,
                        msg: resp.msg
                    }
                }
            },
            height: 600,
            allowResizeX: false,
            allowResizeY: false
        };
        this._editor = new Jodit(this.el.nativeElement, editorOps);
        this._editor.setEditorValue(this.model.content);
    }

    fromModel() {
        this._editor.setEditorValue(this.model.content);
        if (!this.model.images) this.model.images = [];
        if (!this.model.seo) this.model.seo = {};
        if (!this.model.seo.title) this.model.seo.title = this.model.title;
        if (this.model.schema) {
            let item = _.find(this.schemas, { label: this.model.schema});
            console.log('ITEM: ',item, this.schemas, this.model.schema);
            if (item) {
                this.schema = item.value;
                this.form.schema = JSON.parse(item.value.schema);
                this.form.layout = JSON.parse(item.value.layout);
                if (!this.model.data) this.model.data = JSON.parse(item.value.data);
            }
        }
        this.path = this.model.path;
    }

    toModel() {
        this.model.content = this._editor.getEditorValue();
    }

    onChangePath(path: string) {
        let split = path.split('/');
        let temp = split.map(str => slugize(str));
        this.model.path = temp.join('/');
    }

    onChangeTitle(title: string) {
        if (this.model.seo.title === this.model.title) {
            this.model.seo.title = title;
        }
        this.model.title = title;
    }

    onChangeSchema(event:any) {
        if (!event.value) {
            this.form = {};
            this.model.schema = null;
            return;
        }
        this.form.schema = JSON.parse(event.value.schema);
        this.form.layout = JSON.parse(event.value.layout);
        this.model.data = JSON.parse(event.value.data);
        this.model.schema = event.value.name;
    }

    async onSubmitSchemaForm(event: any) {
        console.log(event);
        const validate = this.ajv.compile(this.schema);
        const valid = validate(event);
        if (!valid) console.log('NOT VALID');
    }

    async save() {
        this.msgs = [];
        this.toModel();
        if (this.action == 'create') {
            try {
                const params = {site: this.siteId, path: this.model.path};
                await this._awsService.api.sitesSitePagesHead(params);
                this.msgs.push({severity: 'error', summary: 'La url ya existe'});
                return;
            } catch (err) {
            }
            try {
                this.model = (await this._awsService.api.sitesSitePagesPost({site: this.siteId}, this.model)).data;
                this.action = 'update';
                this.fromModel();
                this.msgs.push({severity: 'success', summary: 'La página se ha creado correctamente'});
            } catch (err) {
                this.msgs.push({severity: 'error', summary: 'Error en la creación', detail: err});
                return;
            }
        } else if (this.action == 'update') {
            const additionalParams:any = {queryParams: {}};
            if (this.path !== this.model.path) {
                try {
                    const params = {site: this.siteId, path: this.model.path};
                    await this._awsService.api.sitesSitePagesHead(params);
                    this.msgs.push({severity: 'error', summary: 'La url ya existe'});
                    return;
                } catch (err) {
                    additionalParams.queryParams.path = this.model.path;
                }
            }
            try {
                let params = {site: this.siteId, path: this.path};
                this.model = (await this._awsService.api.sitesSitePagesPathPut(params, this.model)).data;
                this.fromModel();
                this.msgs.push({severity: 'success', summary: 'La Página se ha actualizado correctamente'});
            } catch (err) {
                this.msgs.push({severity: 'error', summary: 'Error en la actualización', detail: err});
                return;
            }
        }
    }

    async uploadHandler(event: any, uploader: any) {
        this.msgs = [];
        try {
            const s3 = new this._awsService.AWS.S3(this._awsService.credentials);
            const path = config.S3_PREFIX + this._awsService.identityId + '/pages/up/';
            const filename = slugize(Utils.basename(event.files[0].name)) + '.' + Utils.extension(event.files[0].name);
            const key = path + filename;
            const params = {Bucket: config.S3_BUCKET, Key: key, Body: event.files[0], ACL: 'public-read'};
            const data = await s3.upload(params).promise();
            const image = _.find(this.model.images, {name: filename});
            if (!image) this.model.images.push({name: filename, url: data.Location});
            uploader.clear();
            this.msgs.push({severity: 'success', summary: 'La imagen se ha subido correctamente'});
        } catch (err) {
            this.msgs.push({severity: 'error', summary: 'Error en la la subida de archivos', detail: err});
        }
    }

    showImageDlg(image: Image) {
        this.selectedImage = image;
        this.imageDialog = true;
    }

    removeImage(image: Image) {
        _.remove(this.model.images, (img) => (img.name === image.name));
    }

    updateImage() {
        this.selectedImage = {};
        this.imageDialog = false;
    }

    async publish() {
        this.msgs = [];
        if (!this.model.path || !this.model.site) return;
        try {
            this.model.published = true;
            this.model.publishedAt = new Date();
            const params = {site: this.model.site, path: this.model.path};
            this.model = (await this._awsService.api.sitesSitePagesPathPut(params, this.model)).data;
            this.fromModel();
            this.msgs.push({severity: 'success', summary: 'El Post se ha publicado correctamente'});
        } catch (err) {
            this.msgs.push({severity: 'error', summary: 'Error en la publicación', detail: err});
        }
    }

    async unpublish() {
        this.msgs = [];
        if (!this.model.path || !this.model.site) return;
        try {
            this.model.published = false;
            const params = {site: this.model.site, path: this.model.path};
            this.model = (await this._awsService.api.sitesSitePagesPathPut(params, this.model)).data;
            this.fromModel();
            this.msgs.push({severity: 'success', summary: 'El Post se ha despublicado correctamente'});
        } catch (err) {
            this.msgs.push({severity: 'error', summary: 'Error en la publicación', detail: err});
        }
    }

}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/pages/page-form.component.ts